/**
 * Pasted markup as a document of its own, which runs no script and loads no
 * image. Markup set as `innerHTML` in the page runs its inline handlers, even
 * in a detached element, and a table copied from any web page can carry them.
 */
export function inertDocument(html: string): Document {
  return new DOMParser().parseFromString(html, 'text/html');
}
